<template>
  <div id="center-client-acquisition" class="p-6 flex flex-col gap-5">
    <div class="p-6 flex items-center justify-between gap-4 bg-pure-white rounded-3xl border border-slate-400">
      <div class="flex flex-col gap-2">
        <BlTextTitle4 text="Parents' Form" />
        <BlTextBody2 text="Customize and edit the questions in the parents' form." />
      </div>
      <router-link to="/center/client-acquisition/form">
        <BlInputButton label="View form" />
      </router-link>
    </div>
    <div class="p-6 flex items-center justify-between gap-4 bg-pure-white rounded-3xl border border-slate-400">
      <div class="flex flex-col gap-2">
        <BlTextTitle4 text="Tags" />
        <BlTextBody2 text="These tags will only be visible during the client acquisition process, and their data can be visualized in the data analytics." />
      </div>
      <router-link to="/repository?tab=prospect">
        <BlInputButton label="View tags" />
      </router-link>
    </div>
  </div>
</template>

<script>
import BlTextTitle4 from "../BlTextTitle4.vue";
import BlTextBody2 from "../BlTextBody2.vue";
import BlInputButton from "../BlInputButton.vue";

export default {
  name: "CenterClientAcquisition",
  components: {
    BlTextTitle4,
    BlTextBody2,
    BlInputButton
  }
};
</script>



// WEBPACK FOOTER //
// src/components/center/CenterClientAcquisition.vue